<template>
  <div>

    <Cbarra>
        <template slot="slotTitle">Comunidad</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'integrantes'}">Comunidad</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-uno-tab" data-toggle="pill" href="#v-pills-uno"
                            role="tab" aria-controls="v-pills-uno" aria-selected="true">
                            Unidad Servicios Documentales
                        </a>
                        <a class="nav-link" id="v-pills-dos-tab" data-toggle="pill" href="#v-pills-dos" role="tab"
                            aria-controls="v-pills-dos" aria-selected="false">
                            Cómputo y Telecomunicaciones
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">

                        <div class="tab-pane fade show active" id="v-pills-uno" role="tabpanel"
                            aria-labelledby="v-pills-uno-tab">

                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes>

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <!-- <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel> -->
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->

                        </div>

                        <div class="tab-pane fade" id="v-pills-dos" role="tabpanel" aria-labelledby="v-pills-dos-tab">

                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes>

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <!-- <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel> -->
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>

                                        </div>
                                    </div><!--fin del tema-->
                                </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
  </div>
</template>

<script>
export default {
    data() {
        return {
            urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'Comunidad',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnsTema:{
                emitAdd: 'Nuevo',
                emitDel: 'deleteTema',
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'deleteDetalle',
            },
            configBtnContactos:{
                emitAdd: 'FormContactos',
                emitDel: 'deleteContacto',
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },
            objTema1:{
                editar:false,
                Apartado: 'UNIDAD',
                Realiza: 'AddTema'
            },
            objTema2:{
                editar:false,
                Apartado: 'COMPUTO',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'UNIDAD',
                ListaDet: [],
            },
            objTab2:{
                editar:false,
                Apartado: 'COMPUTO',
                ListaDet: [],
            },
            RutaFile: '',
            RutaFileD: '',
            listIconos: [],
            contactReturn: 'comunidad',
        }
    },methods: {
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'COMUNIDAD',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				// this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				// this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				// this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                // this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'UNIDAD'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'COMPUTO'){
                        newObj2.push(value)
                    }                    
                });
                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }
            });
        },
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },mounted() {
        
        window.scrollTo(0, 0);
        this.Lista();
        
    },
}
</script>